import { IsSSRType } from "@website/utils/is-ssr/is-ssr.types";

export const isSSR: IsSSRType = () =>
  typeof document === "undefined" || typeof window === "undefined";
